import React, { useEffect, useRef, useState } from "react";
import "react-image-crop/dist/ReactCrop.css";
import "./style.css";
import ReactCrop, {
  centerCrop,
  convertToPixelCrop,
  makeAspectCrop,
  PercentCrop,
} from "react-image-crop";
import setCanvasPreview from "../../setCanvasPreview";
import axios from "axios";
import { useAuth } from "../../global-components/src";
import { useMessage } from "../../global-components/src";
import { Helmet } from "react-helmet-async";
import { Edit } from "react-feather";
import Spinner, { LoadingThreeCircle } from "../../global-components/src/components/spinner/spiner";
import { useNavigate, useSearchParams } from "react-router-dom";
import NavbarTop from "../../components/NavbarTop";
import ConfirmationModal from "../../components/Modals/ConfirmationModal";
import { errorMessage } from "../../utils/TextManagerTwo";
import { PACOCA_API_URL, PACOCA_URL } from "../../global-components/src/utils/vars";
import { getImageUser, sanitizeUsername, validateEmail, validateUsername } from "../../global-components/src/utils/auth";
import { isWeakPassword } from "../../global-components/src/utils/password-security";
import { isIOSWebView, removeToNativeiOS } from "../../utils/platform";
import i18n from "../../global-components/src/i18n";
import { t } from "i18next";
import { verifyLinks } from "../../global-components/src/utils/text";
import { Pencil, Trash2 } from "lucide-react";
import { ProfileFieldKey } from "../../global-components/src/types";
import { useTranslation } from 'react-i18next';
import { uploadToSignedUrl } from '../../utils/signed-upload';

const ASPECT_RATIO = 1;
const MIN_DIMENSION = 150;

const EditAccount = () => {
  const imgRef = useRef<HTMLImageElement | null>(null);
  const previewCanvasRef = useRef<HTMLCanvasElement | null>(null);
  const { token, user, setUser, logout } = useAuth();
  const [imgSrc, setImgSrc] = useState<string>("");
  const [loadingImg, setLoadingImg] = useState(false);
  const [isCroped, setIsCroped] = useState(false);
  const [crop, setCrop] = useState<PercentCrop | undefined>(undefined); // Tipagem correta para crop
  const [error, setError] = useState<string>("");
  const [filtter, setFillter] = useState<string>("info");
  const openModalRef = useRef<HTMLButtonElement | null>(null);
  const closeModalRef = useRef<HTMLButtonElement | null>(null);
  const { setMessage } = useMessage();
  const { t } = useTranslation();
  const [showConfirmationRemoveAccount, setShowConfirmationRemoveAccount] = useState(false);
  const [errorsInput, setErrorsInput] = useState<{ relationship?: string[]; pronoun?: string[]; newPasswordConfirmation?: string[]; password?: string[]; old_password?: string[]; image?: string[]; email?: string[]; name?: string[]; user_name?: string[]; phone?: string[]; site?: string[]; biography?: string[]; sexo?: string[]; birth_date?: string[]; fieldKey?: string[]; valueInput?: string[] }>({});
  // info
  const [name, setName] = useState<string>("");
  const [userName, setUserName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [site, setSite] = useState<string>("");
  const [biography, setBiography] = useState<string>("");
  const [sexo, setSexo] = useState<string>("");
  const [birthDate, setBirthDate] = useState<string>("");
  const [pronoun, setPronoun] = useState<string>("");
  const [relationship, setRelationship] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [loadingDeleteOthers, setLoadingDeleteOthers] = useState<string | null>(null);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [errorModal, setErrorModalPassword] = useState(''); // Adicione um estado para a senha
  const closeRef = useRef<HTMLButtonElement | null>(null);
  const [password, setPassword] = useState(''); // Adicione um estado para a senha
  // senha
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState("");
  const [isLoading, setIsLoading] = useState(false); //
  const [errorModalRemoveAccount, setErrorModalRemoveAccountPassword] = useState(''); // Adicione um estado para a senha
  const closeRefDeleteAccount = useRef<HTMLButtonElement | null>(null);

  // campos a mais
  const [fieldName, setFieldName] = useState("");
  const [privacy, setPrivacy] = useState<"public" | "friends" | "private">("public");
  const [valueInput, setValueInput] = useState("");
  const [values, setValues] = useState<string[]>([]);
  const [fieldKey, setFieldKey] = useState<ProfileFieldKey | "">("");
  const fieldOptions = [
    { key: "music", label: "profile.fields.music" },
    { key: "movies", label: "profile.fields.movies" },
    { key: "languages", label: "profile.fields.languages" },
    { key: "pets", label: "profile.fields.pets" },
    { key: "websites", label: "profile.fields.websites" },
    { key: "hobbies", label: "profile.fields.hobbies" },
    { key: "sports", label: "profile.fields.sports" },
    { key: "activities", label: "profile.fields.activities" },
    { key: "studies", label: "profile.fields.studies" },
    { key: "games", label: "profile.fields.games" },
    { key: "children", label: "profile.fields.children" },
    { key: "drinks", label: "profile.fields.drinks" },
    { key: "foods", label: "profile.fields.foods" },
    { key: "achievements", label: "profile.fields.achievements" },
    { key: "jobs", label: "profile.fields.jobs" },
    { key: "passions", label: "profile.fields.passions" },
    { key: "places", label: "profile.fields.places" },
    { key: "interests", label: "profile.fields.interests" },
    { key: "skills", label: "profile.fields.skills" },
    { key: "recommendations", label: "profile.fields.recommendations" }
  ];
  const relationshipOptions = [
    { key: "prefer_not_to_say", label: "profile.relationship.prefer_not_to_say" },
    { key: "single", label: "profile.relationship.single" },
    { key: "serious_relationship", label: "profile.relationship.serious_relationship" },
    { key: "married", label: "profile.relationship.married" },
    { key: "engaged", label: "profile.relationship.engaged" },
    { key: "seeing_someone", label: "profile.relationship.seeing_someone" },
    { key: "in_love", label: "profile.relationship.in_love" },
    { key: "open_relationship", label: "profile.relationship.open_relationship" },
    { key: "dating", label: "profile.relationship.dating" },
    { key: "separated", label: "profile.relationship.separated" },
    { key: "divorced", label: "profile.relationship.divorced" },
    { key: "widowed", label: "profile.relationship.widowed" },
    { key: "its_complicated", label: "profile.relationship.its_complicated" },
    { key: "sensitive_topic", label: "profile.relationship.sensitive_topic" },
    { key: "not_looking", label: "profile.relationship.not_looking" }
  ];
  const sexOptions = [
    { key: "prefer_not_to_say", label: "profile.sex.prefer_not_to_say" },
    { key: "male", label: "profile.sex.male" },
    { key: "female", label: "profile.sex.female" },
    { key: "other", label: "profile.sex.other" }
  ];
  const pronounOptions = [
    { key: "prefer_not_to_say", label: "profile.pronoun.prefer_not_to_say" },
    { key: "he_him", label: "profile.pronoun.he_him" },
    { key: "she_her", label: "profile.pronoun.she_her" },
    { key: "they_them", label: "profile.pronoun.they_them" },
    { key: "he_they", label: "profile.pronoun.he_they" },
    { key: "she_they", label: "profile.pronoun.she_they" },
    { key: "other", label: "profile.pronoun.other" }
  ];

  const isValidKey = (
    key: string,
    options: { key: string }[]
  ) => {
     const fieldKeysSet = new Set(options.map(o => o.key));
     return fieldKeysSet.has(key);
  };


  const navigate = useNavigate();

  const closeModal = () => {
    closeModalRef.current?.click()
  }

  const onClose = () => {
    setPassword("");
    setShowConfirmation(false)
  }

  const handleAddValue = (e: any) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();

      const newValue = valueInput.trim().replace(",", "");

      if (newValue && !values.includes(newValue)) {
        setValues([...values, newValue]);
      }

      setValueInput("");
    }
  };

  const removeValue = (index: number) => {
    setValues(values.filter((_, i) => i !== index));
  };


  useEffect(() => {
    const type = searchParams.get("type"); // Pega o valor do parâmetro "type" na URL
    if (type) setFillter(type);
  }, [searchParams]);

  useEffect(() => {
    setImgSrc(getImageUser(user?.img_account || ""))
  }, [user])

  const handleForgetPassowrd = async () => {
    const lastRequestTime = localStorage.getItem("lastForgotPasswordRequest");
    const now = Date.now();
    const cooldownTime = 60 * 1000; // 1 minuto (ajuste conforme necessário)

    if (lastRequestTime && now - parseInt(lastRequestTime) < cooldownTime) {
        setMessage("Você já solicitou a redefinição de senha. Aguarde um momento antes de tentar novamente.", "warning", "Aguarde");
        return;
    }
    
    try {
      setLoadingData(true)
      
      const response = await axios.post(`${PACOCA_API_URL}/forgot-password`, {
        email
      }, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        }
      });

      const data = response.data;
      const message = data.message || "Link de redefinição de senha enviado por email.";
      const title = data.title || null;
      const type = data.type_message || "success";
      setMessage(message, type, title)
      localStorage.setItem("lastForgotPasswordRequest", now.toString()); // Salva o tempo da última solicitação
    } catch (err: any) {
      const messageError = errorMessage(err)
      const type = err?.response?.data?.type_message  || "error";
      setMessage(messageError, type, "Erro ao enviar link de redefinição")
      console.error('Erro:', err);
      console.error(messageError);
    } finally {
      setLoadingData(false)
    }
  }

  const updateImage = async () => {
    let file: File | null = null;
    if (loadingImg) return;
    setLoadingImg(true)
    setErrorsInput({});
    // Envia a imagem para o backend
    try {
      // Verifica se o previewCanvasRef existe
      if (previewCanvasRef.current && isCroped) {
        const dataUrl = previewCanvasRef.current.toDataURL("image/png");
        const blob = await fetch(dataUrl).then(res => res.blob()); // Converte o Data URL para Blob
        file = new File([blob], "cropped-image.png", { type: "image/png" }); // Cria um arquivo a partir do Blob

      } else {
        // Caso previewCanvasRef não exista, pega a imagem diretamente do input
        const inputFile = document.getElementById('image') as HTMLInputElement; // Altere 'your-input-id' para o ID real do seu input
        if (inputFile.files && inputFile.files.length > 0) {
          file = inputFile.files[0]; // Obtém o arquivo do input
        } else {
          let errors: Record<string, string[]> = {};
          errors.image = [t("errors.input.required", { field: t("inputs.banner") })];

          if (Object.keys(errors).length > 0) {
            throw {
              response: {
                data: {
                  errors
                }
              }
            };
          }
          return; // Sai da função se não houver arquivo
        }
      }

      const formData = new FormData();
      const uploadPayload = [
          { type: "image" }
      ];

      const { data: uploadUrls } = await axios.post(PACOCA_API_URL + "/generate-upload-urls",{ files: uploadPayload }, {
          headers: {
              Authorization: `Bearer ${token}`
          }
      });
      await uploadToSignedUrl(axios, uploadUrls[0].url, file);

      formData.append("image_path", uploadUrls[0].path);

      const response = await axios.post(`${PACOCA_API_URL}/account/update/photo`, formData, {
        headers: {
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

      setUser(prev => prev && { ...prev, img_account: response.data.img_account });
      setMessage(response.data.message, "success")
      setLoadingImg(false);
    } catch (err: any) {
      setLoadingImg(false)
      console.error(err);
      if (err?.response?.data.errors) {
        setErrorsInput(err.response.data.errors); // Atualiza o estado com os erros
      } else {
        const messageError = errorMessage(err)
        setMessage(messageError, "error")
        console.error(err);
        console.error(messageError);
      }
    }
  };

  const onSelectFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.addEventListener("load", () => {
      const imageElement = new Image();
      const imageUrl = reader.result?.toString() || "";
      imageElement.src = imageUrl;
      setImgSrc(imageUrl);

      // Verifique se o arquivo é um GIF
      if (file.type === "image/gif") {
        // Defina a imagem diretamente no preview
        setImgSrc(imageUrl);
        return; // Impede a execução posterior se for um GIF
      }

      imageElement.addEventListener("load", (event) => {
        if (error) setError("");
        const target = event.currentTarget as HTMLImageElement;

        const { naturalWidth, naturalHeight } = target;

        if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
          setError("A imagem precisa ter 150 x 150 pixels.");
          return setImgSrc("");
        }
        openModalRef.current?.click()
      });
    });
    reader.readAsDataURL(file);
  };


  const onImageLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const { width, height } = e.currentTarget;
    // const cropWidthInPercent = (MIN_DIMENSION / width) * 400;
    const cropWidthInPercent = 100;

    const crop = makeAspectCrop(
      {
        unit: "%",
        width: cropWidthInPercent,
      },
      ASPECT_RATIO,
      width,
      height
    );

    const centeredCrop: PercentCrop | null = centerCrop(crop, width, height);
    if (centeredCrop) {
      setCrop(centeredCrop); // O tipo deve ser compatível agora
    }
  };

  const handleCropImage = () => {
    if (crop) { // Verifica se crop não é undefined
      setCanvasPreview(
        imgRef.current, // HTMLImageElement
        previewCanvasRef.current, // HTMLCanvasElement
        convertToPixelCrop(
          crop,
          imgRef?.current?.width || 0,
          imgRef?.current?.height || 0
        )
      );
      const dataUrl = previewCanvasRef.current?.toDataURL();
      setImgSrc(dataUrl || "")
      closeModal();
      setIsCroped(true)
    }
  };


  const loadData = async () => {
    setLoadingData(true)
    const response = await axios.get(`${PACOCA_API_URL}/user`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = response.data;

    if (data) {
      setName(data.name)
      setUserName(data.user_name)
      setPhone(data.phone || "")
      setSite(data.site || "")
      setBiography(data.biography || "")
      setSexo(data.sexo || "")
      setBirthDate(data.birth_date ? new Date(data.birth_date).toISOString().split("T")[0] : "")
      setEmail(data.email)
      setRelationship(data.relationship)
      setPronoun(data.pronoun)
    }
    setLoadingData(false)
  }

  useEffect(() => {
    loadData()
  }, [])

  const updateInfo = async () => {
    setLoading(true)
    setErrorsInput({})
    setError("")

    try {
      let errors: Record<string, string[]> = {};
      if (!name) {
        errors.name = [t("errors.input.required", { field: t("inputs.name") })];
      }
      if (validateUsername(userName) != null) {
        errors.user_name = validateUsername(userName) ? [validateUsername(userName)!] : [];
      }
      if (!userName) {
        errors.user_name = [t("errors.input.required", { field: t("inputs.username") })];
      }
      if (userName.length < 3) {
          errors.user_name = [t("errors.input.minLength", { field: t("inputs.username"), min: 3 })];
      }
      if (relationship && !isValidKey(relationship, relationshipOptions)) {
        errors.relationship = [t("errors.input.invalid", { field: t("generics.value") })];
      }
      if (sexo && !isValidKey(sexo, sexOptions)) {
        errors.sexo = [t("errors.input.invalid", { field: t("generics.value") })];
      }


      if (Object.keys(errors).length > 0) {
        throw {
          response: {
            data: {
              errors
            }
          }
        };
      }
      // const formattedDate = new Date(birthDate).toISOString().split('T')[0]; // Garante formato 'YYYY-MM-DD'
      const response = await axios.post(`${PACOCA_API_URL}/user/info`, {
        name, user_name: userName, phone, site, biography, sexo, birth_date: birthDate, relationship, pronoun
      }, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}` // Adicione o token aqui
        }
      });

      setUser(prev => prev && { ...prev, name: name, user_name: userName });
      setMessage(response.data.message, "success");
      navigate(`/@${userName}`);
    } catch (err: any) {
      if (err?.response?.data.errors) {
        setErrorsInput(err.response.data.errors); // Atualiza o estado com os erros
      } else {
        if (err.status == 429 && err.message.blocked)
          setMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }), "error");

        if (err.status == 429)
          setMessage(t("generics.errors.tooManyRequestsGeneric"), "error");

        if (err.response) {
          // O servidor respondeu com um código de erro
          console.error("Erro no servidor:", err.response.status, err.response.data);
          setMessage(err.response.data.message || "Erro salvar dados!", "error");
        } else if (err.request) {
          // A requisição foi feita, mas não houve resposta
          console.error("Nenhuma resposta do servidor:", err.request);
          setMessage(t("generics.errors.genericServerError"), "error");
        } else {
          // Outro tipo de erro (ex: erro de configuração)
          console.error("Erro inesperado:", err.message);
          setMessage("Ocorreu um erro inesperado!", "error");
        }
      }
      console.error(err);

    }
    setLoading(false)
  }

  useEffect(() => {
    if (!fieldKey || !user?.custom_fields) return;

    const existingField = user.custom_fields.find(
      (f) => f.key === fieldKey
    );

    if (existingField) {
      setValues(existingField.values);
      setPrivacy(existingField.privacy);
    } else {
      setValues([]);
      setPrivacy("public");
    }
  }, [fieldKey, user]);


  const updateOthersInfo = async() =>{
    setLoading(true)
    setErrorsInput({})
    setError("")
    const oldFieldKey = fieldKey;
    const oldValueInput = valueInput;
    const oldValues = values;

    try {
      let errors: Record<string, string[]> = {};
      if (!fieldKey) {
        errors.fieldKey = [t("errors.input.required", { field: t("inputs.name") })];
      }
      if (!values.length) {
        errors.valueInput = [t("errors.input.required", { field: t("generics.value") })];
      }
      if (values.length > 5) {
        errors.valueInput = [t("errors.input.maxLength", { field: t("generics.value"), max: 5 })];
      }
      values.forEach((value, index) => {
        if (value.length > 255) {
          errors.valueInput = [
            t("errors.input.maxLength", { field: t("generics.value"), max: 255 })
          ];
        }

        if (verifyLinks(value)) {
          errors.valueInput = [
            t("errors.input.invalid", { field: t("generics.value") })
          ];
        }
      });
      if (fieldKey && !isValidKey(fieldKey, fieldOptions)) {
        errors.fieldKey = [t("errors.input.invalid", { field: t("inputs.name") })];
      }


      if (Object.keys(errors).length > 0) {
        throw {
          response: {
            data: {
              errors
            }
          }
        };
      }

      
      setFieldKey("");
      setValueInput("");
      setValues([]);

      const response = await axios.post(`${PACOCA_API_URL}/user/others-infos`, {
        key: fieldKey, privacy, values
      }, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}` // Adicione o token aqui
        }
      });

      setMessage(response.data.message, "success");
      setUser((prevUser) => {
        if (!prevUser) return prevUser;
        if (!fieldKey) return prevUser;

        const existingIndex = prevUser.custom_fields?.findIndex(
          (field) => field.key === fieldKey
        );

        let updatedFields = [...(prevUser.custom_fields || [])];

        if (existingIndex !== undefined && existingIndex >= 0) {
          // Atualiza campo existente
          updatedFields[existingIndex] = {
            key: fieldKey,
            privacy,
            values
          };
        } else {
          // Adiciona novo campo
          updatedFields.push({
            key: fieldKey,
            privacy,
            values
          });
        }

        return {
          ...prevUser,
          custom_fields: updatedFields
        };
      });

    } catch (err: any) {
      setFieldKey(oldFieldKey);
      setValueInput(oldValueInput);
      setValues(oldValues);
      if (err?.response?.data.errors) {
        setErrorsInput(err.response.data.errors); // Atualiza o estado com os erros
      } else {
        if (err.status == 429 && err.message.blocked)
          setMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }), "error");

        if (err.status == 429)
          setMessage(t("generics.errors.tooManyRequestsGeneric"), "error");

        if (err.response) {
          // O servidor respondeu com um código de erro
          console.error("Erro no servidor:", err.response.status, err.response.data);
          setMessage(err.response.data.message || "Erro salvar dados!", "error");
        } else if (err.request) {
          // A requisição foi feita, mas não houve resposta
          console.error("Nenhuma resposta do servidor:", err.request);
          setMessage(t("generics.errors.genericServerError"), "error");
        } else {
          // Outro tipo de erro (ex: erro de configuração)
          console.error("Erro inesperado:", err.message);
          setMessage("Ocorreu um erro inesperado!", "error");
        }
      }
      console.error(err);

    }
    setLoading(false)
  }

  const handleEditField = (field: any) => {
    setFieldKey(field.key);
    setValues(field.values);
    setPrivacy(field.privacy ?? "public");

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  const handleDeleteField = async (key: string) => {
    setLoadingDeleteOthers(key);

    try {
      await axios.delete(
        `${PACOCA_API_URL}/user/others-infos/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setUser((prevUser) => {
        if (!prevUser) return prevUser;

        return {
          ...prevUser,
          custom_fields: prevUser.custom_fields?.filter(
            (field) => field.key !== key
          )
        };
      });

      setMessage("Campo removido com sucesso!", "success");
    } catch (err) {
      setMessage("Erro ao remover campo", "error");
    } finally {
      setLoadingDeleteOthers(null)
    }
  };

  const updateEmail = async () => {
    setLoading(true)
    setErrorsInput({})
    setError("")
    setErrorModalPassword("")
    let isErrorModal = false;

    try {
      if (!password) {
        isErrorModal = true;
        setErrorModalPassword("Informe sua senha")
        return;
      }

      let errors: Record<string, string[]> = {};
      if (!email) {
        errors.name = [t("errors.input.required", { field: t("inputs.email") })];
      }

      if (validateEmail(email)) {
        errors.email = [validateEmail(email) ?? ""];
      }

      if (Object.keys(errors).length > 0) {
        throw {
          response: {
            data: {
              errors
            }
          }
        };
      }
      // const formattedDate = new Date(birthDate).toISOString().split('T')[0]; // Garante formato 'YYYY-MM-DD'
      const response = await axios.post(`${PACOCA_API_URL}/user/email`, {
        email, password
      }, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}` // Adicione o token aqui
        }
      });

      setMessage(response.data.message, "success");
      navigate(`/@${user?.user_name}`);
    } catch (err: any) {
      if (err?.response?.data.errors) {
        setShowConfirmation(false);
        setErrorsInput(err.response.data.errors); // Atualiza o estado com os erros
      } else {
        if (err.status == 429 && err.message.blocked)
          setMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }), "error");

        if (err.status == 429)
          setMessage(t("generics.errors.tooManyRequestsGeneric"), "error");

        if (err.response) {
          // O servidor respondeu com um código de erro
          console.error("Erro no servidor:", err.response.status, err.response.data);
          setMessage(err.response.data.message || "Erro salvar dados!", "error");
        } else if (err.request) {
          // A requisição foi feita, mas não houve resposta
          console.error("Nenhuma resposta do servidor:", err.request);
          setMessage(t("generics.errors.genericServerError"), "error");
        } else {
          // Outro tipo de erro (ex: erro de configuração)
          console.error("Erro inesperado:", err.message);
          setMessage("Ocorreu um erro inesperado!", "error");
        }
      }
      console.error(err);

    } finally {
      setPassword("");
      setLoading(false)
      if (!isErrorModal) setShowConfirmation(false)
    }
  }
  const updatePassword = async () => {
    setLoading(true)
    setErrorsInput({})
    setError("")
    setErrorModalPassword("")
    try {

      let errors: Record<string, string[]> = {};
      if (!oldPassword) {
        errors.old_password = [t("errors.input.required", { field: t("inputs.password") })];
      }
      if (!newPassword) {
        errors.password = [t("errors.input.required", { field: t("inputs.password") })];
      }
      if (oldPassword == newPassword) {
        errors.password = [t("errors.input.invalid", { field: t("inputs.password") })];
      } else if (newPassword && isWeakPassword(newPassword)) {
        errors.password = [t("errors.input.passwordWeak")];
      }
      if (!newPasswordConfirmation) {
        errors.newPasswordConfirmation = [t("errors.input.required", { field: t("inputs.passwordConfirmation") })];
      }
      if (newPassword != newPasswordConfirmation) {
        errors.password = [t("errors.input.passwordMismatch")];
      }


      if (Object.keys(errors).length > 0) {
        throw {
          response: {
            data: {
              errors
            }
          }
        };
      }
      const response = await axios.post(`${PACOCA_API_URL}/user/password`, {
        old_password: oldPassword, password: newPassword, password_confirmation: newPasswordConfirmation
      }, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}` // Adicione o token aqui
        }
      });

      setNewPassword("")
      setNewPasswordConfirmation("")
      setOldPassword("")
      setMessage(response.data.message, "success");
      navigate(`/@${user?.user_name}`);
    } catch (err: any) {
      if (err?.response?.data.errors) {
        setErrorsInput(err.response.data.errors); // Atualiza o estado com os erros
      } else {
        if (err.status == 429 && err.message.blocked)
          setMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }), "error");

        if (err.status == 429)
          setMessage(t("generics.errors.tooManyRequestsGeneric"), "error");

        if (err.response) {
          // O servidor respondeu com um código de erro
          console.error("Erro no servidor:", err.response.status, err.response.data);
          setMessage(err.response.data.message || "Erro salvar dados!", "error");
        } else if (err.request) {
          // A requisição foi feita, mas não houve resposta
          console.error("Nenhuma resposta do servidor:", err.request);
          setMessage(t("generics.errors.genericServerError"), "error");
        } else {
          // Outro tipo de erro (ex: erro de configuração)
          console.error("Erro inesperado:", err.message);
          setMessage("Ocorreu um erro inesperado!", "error");
        }
      }
      console.error(err);

    } finally {
      setLoading(false)
    }
  }

  const confirmDeleteAccount = async (password: string) => {
        setIsLoading(true)
        const url = `${PACOCA_API_URL}/users`;
        if (!password) {
            setErrorModalRemoveAccountPassword("Informe sua senha")
            setIsLoading(false)
            return;
        }

        try {
            await axios.delete(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                params: { id_user: user?.id, password }
            });

            setMessage("Conta excluida", "success");
            setPassword("");
            setShowConfirmationRemoveAccount(false)
            setShowConfirmation(false)
            setShowConfirmationRemoveAccount(false)
            setTimeout(() => {
                logout()
            }, 500)

        } catch (err: any) {
            // if (err?.response?.data.errors) {
            //     setErrorModalRemoveAccountPassword(err.response.data.errors); // Atualiza o estado com os erros
            // } if (err?.response?.data.error) {
            //     setErrorModalRemoveAccountPassword(err.response.data.error); // Atualiza o estado com os erros
            // } else {
            const messageError = errorMessage(err);
            setErrorModalRemoveAccountPassword(messageError);
            console.error("Erro apagar conta: ", messageError);
            console.error("Erro apagar conta: ", err);
            // }
        } finally {
            setIsLoading(false)
        }
    };


  const updateFilter = (type: string) => {
    setFillter(type); // Atualiza o estado
    setSearchParams({ type }, { replace: true }); // Atualiza a URL
  };

  const onChangeUsername = (value: string) => {
    const sanitized = sanitizeUsername(value);
    setUserName(sanitized);
};


  return (
    <div className="container container-edit-account">
      <Helmet>
        <title>Paçoca - Atualizar Conta</title>
        <meta name="description" content={`Paçoca - Atualize suas informações pessoais!`} />
        <meta name="keywords" content={`Paçoca, rede social brasileira, Atualize suas informações pessoais, informações, dados}`} />
        <meta name="author" content="Paçoca Inc." />
        <meta property="og:title" content={`Atualize suas informações pessoais - Rede Social`} />
        <meta property="og:description" content={`Atualize suas informações pessoais`} />
        <meta property="og:image" content="/img/link-preview.png?v=1" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`Atualize suas informações pessoais - Rede Social`} />
        <meta name="twitter:description" content={`Paçoca - Atualizar Conta`} />
        <meta name="twitter:image" content="/img/link-preview.png?v=1" />
      </Helmet>

      <NavbarTop />

      <ConfirmationModal
          show={showConfirmationRemoveAccount}
          onClose={() => setShowConfirmationRemoveAccount(false)}
          onConfirm={() => confirmDeleteAccount(password)} // Passa a senha aqui
          title='Apagar conta?'
          text='Seu perfil e posts serão excluidos imediatamente e não é possível recuperar os dados. Esta ação é irreversível.'
          requirePassword={true}
          setPassword={setPassword} // Adicione a função setPassword aqui
          errorMessage={errorModalRemoveAccount}
          isLoading={isLoading}
          closeRef={closeRefDeleteAccount}
          idModal="delete-accounnt"
      />

      <ConfirmationModal
        show={showConfirmation}
        onClose={() => onClose()}
        onConfirm={() => updateEmail()} // Passa a senha aqui
        title='Atualizar email'
        text='Você precisará fazer a verificação de email novamente'
        requirePassword={true}
        setPassword={setPassword} // Adicione a função setPassword aqui
        errorMessage={errorModal}
        isLoading={loading}
        closeRef={closeRef}
      />

      {!removeToNativeiOS(user?.id) && (
        <div className="row row-edit-account" style={{ display: "flex", justifyContent: "center", paddingTop: "10px" }}>
          <input
            type="file"
            name="image"
            id="image"
            accept="image/*"
            onChange={onSelectFile}
            className="d-none w-full text-sm text-slate-500 file:mr-4 file:py-1 file:px-2 file:rounded-full file:border-0 file:text-xs file:bg-gray-700 file:text-sky-300 hover:file:bg-gray-600"
          />

          <label
            htmlFor="image"
            className="user-select-none label-img img-edit"
            style={{
              backgroundImage: `url("${imgSrc || "/img/img-account.png"}")`,
              border: errorsInput.image && `1px solid red`,
            }}
          >
            <img className="img-preview-edit-account" src={`${imgSrc || "/img/img-account.png"}`} onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }} />
            <div className="div-placeholder-edit-account">
              <img className="img-placeholder" src="/img/photo.png" width="50%" alt="Editar imagem" />
            </div>
            <Edit style={{ width: "25px" }} className="img-pencil-edit-img-account" />
          </label>

          <div className="w-100 d-flex" style={{ marginTop: "10px" }}>
            <button disabled={loadingImg} onClick={updateImage} style={{ width: "150px", margin: "0 auto" }} className="btn btn-blue">
              {loadingImg ? (
                <Spinner size="20px" />
              ) : (
                <div>
                  Salvar
                </div>
              )}

            </button>
          </div>
          <div className="w-100 d-flex" style={{ marginTop: "10px" }}>
            {errorsInput.image && (
              <div role="alert" className="invalid-feedback" style={{ display: "block", width: "450px", margin: "0 auto" }}>{errorsInput.image[0]}</div> // Exibe a mensagem de erro
            )}
          </div>
        </div>
    )}


      {/* MODAL DE CORTAR IMAGEM */}
      <div className="modal fade" id="modal-edit-image" aria-hidden="true">
        <div className="modal-dialog cover-mobile">
          <div id="username-suggestions"></div>
          <div className="modal-content">
            <div className="modal-header" style={{ borderBottom: "0!important", paddingBottom: 0, }}>
              <h5 className="modal-title" id="modal-post">Cortar imagem</h5>
              <button type="button" className="btn-close svg-icons-color btn-dark" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <ReactCrop
                  crop={crop}
                  onChange={(pixelCrop, percentCrop) => setCrop(percentCrop)}
                  circularCrop
                  keepSelection
                  aspect={ASPECT_RATIO}
                  minWidth={MIN_DIMENSION}
                >
                  <img
                    ref={imgRef}
                    src={imgSrc || "/img/img-account.png"}
                    alt="Upload"
                    style={{ maxHeight: "70vh" }}
                    onLoad={onImageLoad}
                  />
                </ReactCrop>

              </div>

              <div className="modal-footer" style={{ padding: "0" }}>
                <button type="submit" className={`btn-subimit-post btn btn-blue`} onClick={handleCropImage}>
                  Cortar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* )} */}
      {crop && (
        <canvas
          ref={previewCanvasRef}
          className="mt-4"
          style={{
            display: "none",
            border: "1px solid black",
            objectFit: "contain",
            width: 150,
            height: 150,
          }}
        />
      )}

      {/* botao para abrir e fechar modal. não remover */}
      <button className="d-none" ref={closeModalRef} data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#modal-edit-image">a</button>
      <button className="d-none" ref={openModalRef} data-bs-toggle="modal" data-bs-target="#modal-edit-image">a</button>


      {/* Editar informações */}
      <div className="row" style={{ display: "flex", justifyContent: "center" }}>
        <div className="col-11 col-md-7 col-lg-7 col-name-user-edit" style={{ padding: 0 }}>
          <div className="col">
            <div className="user-select-none row cursor-pointer row-filtro-edit-account">
            {/* {{-- Icon img --}} */}
            <div onClick={() => updateFilter("info")} className={`col col-filtro ${filtter == "info" ? "filtro-conta-active" : ""}`}>
              <span>
                Informações
              </span>
            </div>

            {/* {{-- Icon all --}} */}
            <div onClick={() => updateFilter("email")} className={`col col-filtro ${filtter == "email" ? "filtro-conta-active" : ""}`}>
              <span>
                Email
              </span>
            </div>
            {/* {{-- Icon all --}} */}
            <div onClick={() => updateFilter("pass")} className={`col col-filtro ${filtter == "pass" ? "filtro-conta-active" : ""}`}>
              <span>
                Senha
              </span>
            </div>
            <div onClick={() => updateFilter("others")} className={`col col-filtro ${filtter == "others" ? "filtro-conta-active" : ""}`}>
              <span>
                Outras Informações
              </span>
            </div>
          </div>
          </div>

          {loadingData ? (
            <div className="d-flex mt-3 w-100" style={{ justifyContent: "center" }}>
              <LoadingThreeCircle/>
              {/* <Spinner size="50px" className="text-primary" /> */}
            </div>

          ) : (
            <>
              {/* INFO */}
              {filtter == "info" ? (
                <div className="row">
                  {/* {{-- Nome --}} */}
                  <div className="col-12 col-lg-6 mt-3">
                    <label htmlFor="name" className="required label-register text-md-right">Nome</label>

                    <div className="col">
                      <input value={name} onChange={(e) => setName(e.target.value)} id="name" type="text" className={`form-control ${errorsInput.name ? 'is-invalid' : ''}`} autoComplete="name" />

                      {errorsInput.name && (
                        <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.name[0]}</div> // Exibe a mensagem de erro
                      )}
                    </div>
                  </div>

                  {/* {{-- Nome de usuário --}} */}
                  <div className="col-12 col-lg-6 mt-3">
                    <label htmlFor="user_name" className="required label-register text-md-right">Nome de usuário</label>

                    <div className="col">
                      <input autoCapitalize="none" value={userName} onChange={(e) => onChangeUsername(e.target.value)} id="user_name" type="text" className={`form-control ${errorsInput.user_name ? 'is-invalid' : ''}`} name="user_name" autoComplete="off" />
                      <div style={{marginTop: "5px"}} id="passwordHelp" className="form-text">Só pode ser alterado a cada 30 dias</div>
                      {errorsInput.user_name && (
                        <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.user_name[0]}</div> // Exibe a mensagem de erro
                      )}
                    </div>
                  </div>

                  {/* {{-- Telefone --}} */}
                  <div className="col-12 col-lg-6 mt-3">
                    <label htmlFor="phone" className=" label-register text-md-right">Telefone</label>

                    <div className="col">
                      <input value={phone} onChange={(e) => setPhone(e.target.value)} id="phone" max="15" type="text" className={`form-control ${errorsInput.phone ? 'is-invalid' : ''}`} name="phone" autoComplete="tel" />
                      {errorsInput.phone && (
                        <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.phone[0]}</div> // Exibe a mensagem de erro
                      )}
                    </div>
                  </div>


                  {/* {{-- Site --}} */}
                  <div className="col-12 col-lg-6 mt-3">
                    <label htmlFor="site" className=" label-register text-md-right">Link</label>

                    <div className="col">
                      <input autoCapitalize="none" value={site} onChange={(e) => setSite(e.target.value)} placeholder={PACOCA_URL} id="site" type="link" className={`form-control ${errorsInput.site ? 'is-invalid' : ''}`} name="site" />
                      {errorsInput.site && (
                        <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.site[0]}</div> // Exibe a mensagem de erro
                      )}
                    </div>
                  </div>

                  {/* {{-- Biografia --}} */}
                  <div className="col-12 mt-3">
                    <label htmlFor="biography" className=" label-register text-md-right">Biografia</label>

                    <div className="col">
                      <textarea style={{ color: "var(--color-text-post)" }} value={biography} onChange={(e) => setBiography(e.target.value)} className={`form-control ${errorsInput.biography ? 'is-invalid' : ''}`} name="biography"/>

                      {errorsInput.biography && (
                        <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.biography[0]}</div> // Exibe a mensagem de erro
                      )}
                    </div> 
                  </div>

                  {/* {{-- Sexo --}} */}
                  <div className="col-12 col-lg-6 mt-3">
                    <label htmlFor="sexo" className=" label-register text-md-right">
                      {t("profile.sex.label")}
                    </label>

                    <div className="col">
                      <select
                        id="sexo"
                        value={sexo}
                        onChange={(e) => setSexo(e.target.value)}
                        className={`form-control ${errorsInput.sexo ? 'is-invalid' : ''}`}
                      >
                        <option value="">
                          {t("generics.select")}
                        </option>
                        {sexOptions.map((option) => (
                          <option key={option.key} value={option.key}>
                            {t(option.label)}
                          </option>
                        ))}
                      </select>
                      {errorsInput.sexo && (
                        <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.sexo[0]}</div>
                      )}
                    </div>
                  </div>

                  {/* {{-- Data de Nascimento --}} */}
                  <div className="col-12 col-lg-6 mt-3">
                    <label htmlFor="birth_date" className=" label-register text-md-right">Data de nascimento</label>

                    <div className="col">
                      <input value={birthDate} onChange={(e) => setBirthDate(e.target.value)} id="birth_date" type="date" className={`form-control ${errorsInput.birth_date ? 'is-invalid' : ''}`} name="birth_date" />
                      <div style={{marginTop: "5px"}} id="passwordHelp" className="form-text">Só pode ser alterado a cada 90 dias</div>
                      {errorsInput.birth_date && (
                        <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.birth_date[0]}</div> // Exibe a mensagem de erro
                      )}
                    </div>
                  </div>

                  {/* {{-- relacionamento --}} */}
                  <div className="col-12 col-lg-6 mt-3">
                    <label className="label-register text-md-right">
                      {t("profile.relationship.label")}
                    </label>

                    <div className="col">
                      <select
                        value={relationship}
                        onChange={(e) => setRelationship(e.target.value)}
                        className={`form-control ${errorsInput.relationship ? 'is-invalid' : ''}`}
                      >
                        <option value="">
                          {t("generics.select")}
                        </option>

                        {relationshipOptions.map((option) => (
                          <option key={option.key} value={option.key}>
                            {t(option.label)}
                          </option>
                        ))}
                      </select>

                      {errorsInput.relationship && (
                        <div className="invalid-feedback" style={{ display: "block" }}>
                          {errorsInput.relationship[0]}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* pronome */}
                  <div className="col-12 col-lg-6 mt-3">
                    <label className="label-register text-md-right">
                      {t("profile.pronoun.label")}
                    </label>

                    <div className="col">
                      <select
                        value={pronoun}
                        onChange={(e) => setPronoun(e.target.value)}
                        className={`form-control ${errorsInput.pronoun ? 'is-invalid' : ''}`}
                      >
                        <option value="">
                          {t("generics.select")}
                        </option>

                        {pronounOptions.map((option) => (
                          <option key={option.key} value={option.key}>
                            {t(option.label)}
                          </option>
                        ))}
                      </select>

                      {errorsInput.pronoun && (
                        <div className="invalid-feedback" style={{ display: "block" }}>
                          {errorsInput.pronoun[0]}
                        </div>
                      )}
                    </div>
                  </div>


                  {/* {{-- Criar Conta --}} */}
                  <div className="col-12">
                    <div className="mt-3 mb-5" style={{ padding: 0 }}>
                      {/* style={{ paddingBottom: "100px" }} */}
                      <button disabled={loading} onClick={updateInfo} type="submit" className="btn btn-blue w-100">
                        {loading ? (
                          <Spinner />
                        ) : (
                          <div>
                            Atualizar
                          </div>
                        )}
                      </button>
                    </div>
                    </div>

                      <div className="col-12">
                        <div className="mb-1" style={{ paddingLeft: 0, paddingRight: 0 }}>
                          <h5 className="fw-bold">Apagar Conta</h5>
                          <p className="text-muted">Remove a conta e todos os dados permanentemente</p>
                        </div>

                        <div className="border mb-5 border-danger bg-danger bg-opacity-10 rounded p-3">
                          <div className="text-danger mb-3">
                            <p className="fw-semibold">Atenção</p>
                            <p className="small">
                              Sua conta será apagada, inclusive todos os posts e dados permanentemente.
                              Esta ação é irreversível.
                            </p>
                          </div>

                          {/* <!-- Botão que abre o modal --> */}
                          {/* <button className="btn btn-danger" data-bs-toggle="modal" data-bs-target="#deleteAccountModal"> */}
                          <button className="btn btn-danger" onClick={() => setShowConfirmationRemoveAccount(true)}>
                            Apagar Conta
                          </button>
                        </div>
                      </div>

                </div>
              ) : null}

              {/* EMAIL */}
              {filtter == "email" ? (
                <div className="row">
                  {/* {{-- Nome --}} */}
                  <div className="col-12 mt-3">
                    <label htmlFor="name" className="required label-register text-md-right">Email</label>

                    <div className="col">
                      <input value={email} onChange={(e) => setEmail(e.target.value)} id="name" type="email" className={`form-control ${errorsInput.email ? 'is-invalid' : ''}`} autoComplete="name" />

                      {errorsInput.email && (
                        <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.email[0]}</div> // Exibe a mensagem de erro
                      )}
                    </div>
                  </div>

                  {/* {{-- Criar Conta --}} */}
                  <div className="col-12 mt-3" style={{ paddingBottom: "100px" }}>
                    <button onClick={() => setShowConfirmation(true)} type="submit" className="btn btn-blue w-100">
                      Atualizar
                    </button>
                  </div>
                </div>
              ) : null}


              {/* PASSWORD */}
              {filtter == "pass" ? (
                <div className="row">
                  {/* {{-- Nome --}} */}
                  <div className="col-md-12 mt-3">
                    <label htmlFor="name" className="required label-register text-md-right">Senha Atual</label>

                    <div className="col">
                      <input name="username" autoComplete="username" className="d-none"/> {/* Campo oculto para evitar remover warning */}
                      <input value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} id="name" type="password" className={`form-control ${errorsInput.old_password ? 'is-invalid' : ''}`} autoComplete="name" />

                      {errorsInput.old_password && (
                        <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.old_password[0]}</div> // Exibe a mensagem de erro
                      )}
                    </div>
                  </div>

                  <a href="#" onClick={() => handleForgetPassowrd()}>Esqueci minha senha</a>

                  <div className="col-12 col-lg-6 mt-3">
                    <label htmlFor="name" className="required label-register text-md-right">Nova Senha</label>

                    <div className="col">
                      <input value={newPassword} onChange={(e) => setNewPassword(e.target.value)} id="name" type="password" className={`form-control ${errorsInput.password ? 'is-invalid' : ''}`} autoComplete="name" />

                      {errorsInput.password && (
                        <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.password[0]}</div> // Exibe a mensagem de erro
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 mt-3">
                    <label htmlFor="name" className="required label-register text-md-right">Confirmar Senha</label>

                    <div className="col">
                      <input value={newPasswordConfirmation} onChange={(e) => setNewPasswordConfirmation(e.target.value)} id="name" type="password" className={`form-control ${errorsInput.newPasswordConfirmation ? 'is-invalid' : ''}`} autoComplete="name" />
                      {errorsInput.newPasswordConfirmation && (
                        <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.newPasswordConfirmation[0]}</div> // Exibe a mensagem de erro
                      )}
                    </div>
                  </div>

                  {/* {{-- Criar Conta --}} */}
                  <div className="col-12 mt-3" style={{ paddingBottom: "100px" }}>
                    <button disabled={loading} onClick={() => updatePassword()} type="submit" className="btn btn-blue w-100">
                      {loading ? (
                        <Spinner />
                      ) : (
                        <div>
                          Atualizar
                        </div>
                      )}
                    </button>
                  </div>
                </div>
              ) : null}


              {filtter === "others" && (
                <div className="row">

                  {/* Nome do Campo */}
                  <div className="col-12 mt-3">
                    <label className="required label-register text-md-right">
                      Nome do campo
                    </label>

                    <div className="col">
                      <select
                        value={fieldKey}
                        onChange={(e) => setFieldKey(e.target.value as ProfileFieldKey)}
                        className={`form-control ${errorsInput.fieldKey ? 'is-invalid' : ''}`}
                      >
                        <option value="">Selecione</option>

                        {fieldOptions.map((option) => (
                          <option key={option.key} value={option.key}>
                            {t(option.label)}
                          </option>
                        ))}
                      </select>
                      {errorsInput.fieldKey && (
                        <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.fieldKey[0]}</div> // Exibe a mensagem de erro
                      )}

                    </div>
                  </div>

                  {/* Privacidade */}
                  {/* <div className="col-12 mt-3">
                    <label className="label-register text-md-right">
                      Privacidade
                    </label>

                    <div className="col">
                      <select
                        value={privacy}
                        onChange={(e) => setPrivacy(e.target.value)}
                        className="form-control"
                      >
                        <option value="public">Qualquer pessoa</option>
                        <option value="friends">Amigos</option>
                      </select>
                    </div>
                  </div> */}

                  {/* Valores */}
                  <div className="col-12 mt-3">
                    <label className="required label-register text-md-right">
                      Conteúdo do campo
                    </label>

                    <div className="col">
                      <input
                        value={valueInput}
                        onChange={(e) => setValueInput(e.target.value)}
                        onKeyDown={handleAddValue}
                        className="form-control"
                        placeholder="Digite e pressione Enter ou vírgula"
                      />
                      {errorsInput.valueInput && (
                        <div className="invalid-feedback" style={{ display: "block" }}>{errorsInput.valueInput[0]}</div> // Exibe a mensagem de erro
                      )}

                      {/* Tags */}
                      <div className="mt-2 d-flex flex-wrap gap-2">
                        {values.map((val, index) => (
                          <span
                            key={index}
                            className="badge badge-more-info"
                            style={{ gap: "5px", paddingLeft: "12px", paddingRight: "12px", paddingTop: "8px", paddingBottom: "8px", minWidth: 53, display: "flex", justifyContent: "space-between", borderRadius: "50" }}
                          >
                            {val}
                            <span
                              style={{ cursor: "pointer", fontWeight: "bold" }}
                              onClick={() => removeValue(index)}
                            >
                              ×
                            </span>
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>

                  {user?.custom_fields && user?.custom_fields?.length > 0 && (
                    <div className="col-12 mt-4">
                      <label className="label-register text-md-right">
                        Campos adicionados
                      </label>

                      <div className="mt-2 d-flex flex-column gap-2">
                        {user.custom_fields.map((field, index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between align-items-center p-3 border rounded"
                          >
                            <div>
                              <strong>{t(`profile.fields.${field.key}`)}</strong>
                              <div className="small text-muted">
                                {field.values.join(", ")}
                              </div>
                            </div>

                            <div className="d-flex gap-1">

                              {/* Editar */}
                              <button
                                type="button"
                                className="btn btn-sm"
                                onClick={() => handleEditField(field)}
                              >
                                <Pencil size={20}/>
                              </button>

                              {/* Remover */}
                              <button
                                type="button"
                                className="btn btn-sm"
                                onClick={() => handleDeleteField(field.key)}
                              >
                                {loadingDeleteOthers == field.key ? (
                                  <Spinner />
                                ) : (
                                  <Trash2 size={20}/>
                                )}
                              </button>

                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Botão */}
                  <div className="col-12 mt-3" style={{ paddingBottom: "100px" }}>
                    <button disabled={loading} onClick={() => updateOthersInfo()} type="submit" className="btn btn-blue w-100">
                      {loading ? (
                        <Spinner />
                      ) : (
                        <div>
                          Atualizar
                        </div>
                      )}
                    </button>
                  </div>
                </div>
              )}

            </>
          )}
        </div>
      </div >
    </div >
  );
};

export default EditAccount;
